import {createAsyncThunk} from "@reduxjs/toolkit"
import {AppThunkProps} from "store"
import {api} from "utils/http"
import {ApplicationOrderResponse} from "types/Report"

type ReturnedType = {
    status: boolean
    data: ApplicationOrderResponse
}

export const fetchApplicationOrder = createAsyncThunk<ReturnedType, number, AppThunkProps>(
    "fetch/order/application-id",
    async (applicationId, {signal}) => {
        return api.get<ReturnedType>(`/applications/${applicationId}/orders`, {signal})
    }
)
